import "../pages.scss"
import { useParams } from 'react-router-dom';
import { EmpresaFormState } from '../../context/empresa/EmpresaFormState';
import { Form } from './empresaForm/form';

const EmpresaPage = () => {
  return (
    <EmpresaFormState>
      <br />
      <Form title={"Configuración de empresa"} />
    </EmpresaFormState>
  );
}

export default EmpresaPage